// inheriting the base main.js code in custom cartridge
'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');

require('./thirdParty/bootstrap');
require('slick-carousel');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-validation');

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('./login'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('./components/toolTip'));
});

require('base/components/spinner');
